import { getAuth } from "firebase/auth";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { useEffect, useRef, useState } from "react";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";

import { db } from "../../../firebase";
import {
  MultipleQueryTypesense,
  // QueryTypesense
} from "../../../Typesense";
import getFiltersString from "./getFiltersString";
import { useContext } from "react";
import { resultsContext } from "../Properties";

const limitForDocs = 20;

export function useInventoryProperties(
  Type,
  FiltersParams,
  areFiltersSetToDefault
) {
  const setResult = useContext(resultsContext);

  const [Properties, setProperties] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [paginationIndex, setPaginationIndex] = useState(1);

  const [Reset, setReset] = useState(true);
  const lastInventorySnapshot = useRef("*");
  const lastSharedSnapshot = useRef("*");

  const reset = () => {
    setProperties([]);
    setHasMore(true);
    setPaginationIndex(1);
    setReset(!Reset);
  };

  const fetchPropertiesFromAgain = async () => {
    if (!hasMore) return;

    try {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        const PropertiesCollection = collection(db, "properties");
        let q = query(
          PropertiesCollection,
          // where("bid", "==", getLocalStorageItem("bid")),
          where("status", "==", "shared"),
          where("is_deleted", "==", false),
          where("sharedParties", "array-contains", getLocalStorageItem("bid")),
          orderBy("sharedAt", "desc"),
          startAfter(lastSharedSnapshot.current ?? ""),
          limit(limitForDocs)
        );
        const sp = (await getDocs(q)) || [];

        const sharedProperties = sp.docs.map((e) => {
          return {
            ...e.data(),
            id: e.id,
          };
        });
        lastSharedSnapshot.current = sp.docs[sp.docs.length - 1];

        let properties = await getDocs(
          query(
            collection(db, "properties"),
            where("bid", "==", getLocalStorageItem("bid")),
            where("is_deleted", "==", false),
            orderBy("createdAt", "desc"),
            startAfter(lastInventorySnapshot.current ?? ""),
            limit(limitForDocs)
          )
        );

        lastInventorySnapshot.current =
          properties.docs[properties.docs.length - 1];
        properties = properties.docs.map((e) => {
          return { ...e.data(), id: e.id };
        });
        // let properties = [];
        // properties = [
        //   ...((await GetProperties(getAuth().currentUser.uid)) || []),
        // ];
        const fetchedProperties = [...sharedProperties, ...properties];

        let TotalProperties = [...Properties, ...fetchedProperties];

        const PropertiesIds = TotalProperties.map(({ id }) => id);
        const UniquePropertiesIds = Array.from(new Set(PropertiesIds));
        TotalProperties = UniquePropertiesIds.map((uid) =>
          TotalProperties.filter(({ id }) => uid === id).pop()
        );

        if (fetchedProperties.length < limitForDocs) {
          setHasMore(false);
        } else {
          setPaginationIndex(paginationIndex + 1);
        }

        setProperties(TotalProperties);
        setResult(TotalProperties.length);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const fetchPropertiesFromFirestoreFirst = async () => {
    if (!hasMore) return;

    try {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        const PropertiesCollection = collection(db, "properties");
        let q = query(
          PropertiesCollection,
          // where("bid", "==", getLocalStorageItem("bid")),
          where("status", "==", "shared"),
          where("is_deleted", "==", false),
          where("sharedParties", "array-contains", getLocalStorageItem("bid")),
          orderBy("sharedAt", "desc"),
          limit(limitForDocs)
        );
        const sp = (await getDocs(q)) || [];
        const sharedProperties = sp.docs.map((e) => {
          return {
            ...e.data(),
            id: e.id,
          };
        });
        lastSharedSnapshot.current = sp.docs[sp.docs.length - 1];

        let properties = await getDocs(
          query(
            collection(db, "properties"),
            where("bid", "==", getLocalStorageItem("bid")),
            where("is_deleted", "==", false),
            orderBy("createdAt", "desc"),
            limit(limitForDocs)
          )
        );

        lastInventorySnapshot.current =
          properties.docs[properties.docs.length - 1];
        properties = properties.docs.map((e) => {
          return { ...e.data(), id: e.id };
        });

        const fetchedProperties = [...sharedProperties, ...properties];

        let TotalProperties = [...Properties, ...fetchedProperties];

        const PropertiesIds = TotalProperties.map(({ id }) => id);
        const UniquePropertiesIds = Array.from(new Set(PropertiesIds));
        TotalProperties = UniquePropertiesIds.map((uid) =>
          TotalProperties.filter(({ id }) => uid === id).pop()
        );
        setPaginationIndex(paginationIndex + 1);
        if (fetchedProperties.length < limitForDocs) {
          setHasMore(false);
        }

        setProperties(TotalProperties);
        setResult(TotalProperties.length);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const fetchPropertiesFromFirestore = () => {
    if (paginationIndex === 1) {
      fetchPropertiesFromFirestoreFirst();
    } else {
      fetchPropertiesFromAgain();
    }
  };

  const fetchPropertiesFromTypesense = async () => {
    // console.log("Fetching Properties...", PropertyType, PropertySubType);
    if (!hasMore) return;

    try {
      getAuth().onAuthStateChanged(async ({ uid }) => {
        // console.log("called-type", 1);
        const FilterStrings = getFiltersString(FiltersParams);
        // console.log("FilterStrings", FilterStrings);
        let properties = (
          await MultipleQueryTypesense(
            {
              searches: [
                {
                  q: "shared",
                  query_by: "status",
                  filter_by: `${
                    FilterStrings[0]
                  } && sharedParties:=[${getLocalStorageItem(
                    "bid"
                  )}] && is_deleted:=false`,
                  // sort_by: "createdAt: desc,_text_match:desc",
                  sort_by: "sharedAt: desc, _text_match:desc",
                },
                {
                  q: "shared",
                  query_by: "status",
                  filter_by: `${
                    FilterStrings[1]
                  } && sharedParties:=[${getLocalStorageItem(
                    "bid"
                  )}] && is_deleted:=false`,
                  // sort_by: "createdAt: desc,_text_match:desc",
                  sort_by: "sharedAt: desc, _text_match:desc",
                },
                {
                  filter_by: `${FilterStrings[0]}&& is_deleted:=false`,
                  query_by: "bid",
                  q: getLocalStorageItem("bid"),
                  sort_by: "createdAt: desc,_text_match:desc",
                  // sort_by: "createdAt: desc, _text_match:desc",
                },
                {
                  filter_by: `${FilterStrings[1]}&& is_deleted:=false`,
                  query_by: "bid",
                  q: getLocalStorageItem("bid"),
                  // sort_by: "createdAt: desc, _text_match:desc",
                  // sort_by: "createdAt: desc,_text_match:desc",
                },
              ],
            },
            {
              collection: "properties",
              per_page: limitForDocs,
              page: paginationIndex,
              // sort_by: "createdAt: asc",
            }
            // {
            //   collection: "properties",
            //   q: getLocalStorageItem("bid"),
            //   query_by: "bid",
            //   per_page: limitForDocs,
            //   page: paginationIndex,
            // },
            // {
            //   searches: [
            //     {
            //       collection: "properties",
            //       q: "shared",
            //       filter_by: `sharedParties:=[${getLocalStorageItem("bid")}]`,
            //     },
            //   ],
            // },
            // {
            //   collection: "properties",
            //   q: "shared",
            //   query_by: "status",
            //   per_page: limitForDocs,
            //   page: paginationIndex,
            // }
          )
        ).map(({ document }) => document);

        // console.log("toly properties", properties);

        let TotalProperties = [...Properties, ...properties];
        const PropertiesIds = TotalProperties.map(({ id }) => id);
        const UniquePropertiesIds = Array.from(new Set(PropertiesIds));
        // console.log("prop", TotalProperties);
        TotalProperties = UniquePropertiesIds.map((uid) =>
          TotalProperties.filter(({ id }) => uid === id).pop()
        );
        // console.log("prop", TotalProperties);

        setPaginationIndex(paginationIndex + 1);
        if (properties.length < limitForDocs) setHasMore(false);

        // console.log("===shared", properties);

        setProperties(TotalProperties);
        setResult(TotalProperties.length);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProperties = () => {
    if (areFiltersSetToDefault()) {
      fetchPropertiesFromFirestore();
    } else {
      fetchPropertiesFromTypesense();
    }
  };

  useEffect(() => fetchProperties(), [Reset]);
  useEffect(() => reset(), [FiltersParams]);
  useEffect(() => fetchProperties(), []);

  return [Properties, fetchProperties, hasMore];
}
